<template>
  <div>
    <h2>Conversations</h2>
    <ConversationListItem
      v-for="conversation in userData.conversations"
      :conversation="conversation"
      :key="conversation.id"
    />
  </div>
</template>

<script>
import ConversationListItem from "@/views/conversations/components/ConversationListItem";

export default {
  name: "WorkerConversations",
  components: {
    ConversationListItem
  },
  props: {
    userData: {
      type: Object,
      required: true
    }
  }
};
</script>
